const initialState = {
  events: [],
  days: 1,
  selectedCount: 0,
  // Leaving this undefined prevents flickering in schedule template form, because an empty array would show all positions
  // until the template is loaded.
  requiredPositions: null,
  isDirty: false
}

// Function to remove an array of events from the events array
const isMatch = (eventsToMatch = [], idToMatch) => eventsToMatch.map(({ id }) => id).includes(idToMatch)
const removeEvents = (events, eventsToRemove = []) => events.filter(({ id }) => !isMatch(eventsToRemove, id))

const scheduleTemplates = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_TEMPLATE_EVENTS':
      return { ...state, events: action.events, isDirty: false }

    case 'SET_FORM_CLEAN':
      return { ...state, isDirty: false }

    case 'SET_MULTI_TEMPLATE_DAYS':
      // Filters all events that are on deleted days
      return { ...state, days: action.days, events: state.events.filter(({ multiDayIndex }) => multiDayIndex < action.days) }

    case 'SET_TEMPLATE_REQUIRED_POSITIONS':
      return { ...state, requiredPositions: action.requiredPositions }

    case 'ADD_TEMPLATE_EVENTS':
    case 'UPDATE_TEMPLATE_EVENTS':
      return { ...state, events: [...removeEvents(state.events, action.events), ...action.events], isDirty: true }
    case 'REMOVE_TEMPLATE_EVENTS':
      return { ...state, events: [...removeEvents(state.events, action.events)], isDirty: true }

    // Actions for context menu
    case 'REMOVE_EMPLOYEE':
      return {
        ...state,
        events: state.events.map(event => {
          if (isMatch(action.events, event.id)) delete event.employeeId
          return event
        }),
        isDirty: true
      }
    case 'TOGGLE_OVERTIME':
      return {
        ...state,
        events: state.events.map(({ isOvertime, ...event }) => ({ ...event, isOvertime: isMatch(action.events, event.id) ? !isOvertime : isOvertime })),
        isDirty: true
      }
    case 'TOGGLE_VARIABLE_END_TIME':
      return {
        ...state,
        events: state.events.map(({ isExtraShift, ...event }) => ({
          ...event,
          isExtraShift: isMatch(action.events, event.id) ? !isExtraShift : isExtraShift
        })),
        isDirty: true
      }
    case 'SET_TEMPLATE_EVENTS_SELECTED_COUNT': {
      return { ...state, selectedCount: action.count }
    }

    default:
      return state
  }
}

export default scheduleTemplates
